/* eslint-disable @typescript-eslint/no-explicit-any */
import { Modal } from "@/src/components/Modal/Modal";
import { Label, textVariants } from "@/src/components/Text/Text";
import QRCode from "react-qr-code";
import { TFAData } from "../../../types";
import { Copy } from "lucide-react";
import api, { copy } from "@/src/utils";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import apiRoutes from "@/src/apiRoutes";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import useUrlState from "@/src/hooks/use-url-state";
import { PinInput } from "@mantine/core";
import { Button } from "@/src/components/Button/Button";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  setOpen: (val: any) => void;
  data: TFAData | undefined;
}

const tfaState = z.object({
  code: z.string(),
});

const EnableTfaApp = ({ open, setOpen, data }: Props) => {
  const { t } = useTranslation();
  const trans = (key: string) =>
    t(`app.settings.securityCenter.verificationMethods.authApp.modal.${key}`);
  type tfaInput = z.infer<typeof tfaState>;
  const [, setModal] = useUrlState("modal");

  const { setValue, getValues, handleSubmit } = useForm<tfaInput>({
    resolver: zodResolver(tfaState),
  });

  const activate = async () => {
    const res = await api.post(apiRoutes.tfa, {
      type: "activate",
      code: getValues().code,
    });
    return res.data;
  };

  const { mutate, isLoading: activateLoad } = useMutation({
    mutationKey: ["activate_tfa"],
    mutationFn: activate,
    onSuccess: (data) => {
      if (data?.success) {
        toast.success(data?.info);
        setModal(undefined);
      } else {
        toast.warning(data?.info);
      }
    },
  });
  const onSubmit = () => {
    mutate();
  };
  return (
    <Modal
      title={trans("title")}
      description={trans("desc")}
      open={open}
      setOpen={setOpen}
    >
      <div className="flex items-center mb-2 justify-center">
        <QRCode size={200} value={data?.info?.scan ?? ""} />
      </div>
      <div className="flex justify-center gap-2 items-center flex-col">
        <span className="p-1 text-sm rounded border flex gap-3 items-center cursor-pointer">
          <span className={textVariants()}>{data?.info?.code}</span>{" "}
          <span onClick={() => copy(data?.info?.code as string)}>
            <Copy className="h-4 w-4 text-gray-600" />
          </span>
        </span>
        <Label>{trans("body.desc")}</Label>
        <PinInput onChange={(val) => setValue("code", val)} length={6} />
      </div>
      <div className="mt-5">
        <Button
          className="w-full"
          // title="Save"
          type={"submit"}
          variant="primary"
          onClick={handleSubmit(onSubmit)}
          loading={activateLoad}
        >
          {trans("activateButton")}
        </Button>
      </div>
    </Modal>
  );
};

export default EnableTfaApp;
